import React, { useEffect, useState } from 'react';
import LoadingScreen from './apps/gallery/components/common/LoadingScreen';
import ErrorScreen from './apps/gallery/components/common/ErrorScreen';
import { resolveDomainInfo, type DomainInfo } from '@utils/domainRouting';

// Import both applications
import GalleryApp from './apps/gallery/GalleryApp'; // New gallery micro site

// Legacy App for existing routes
import App from './App';

const AppRouter: React.FC = () => {
  const [domainInfo, setDomainInfo] = useState<DomainInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const detectDomain = () => {
      try {
        const hostname = window.location.hostname;
        const pathname = window.location.pathname;

        setDomainInfo(resolveDomainInfo(hostname, pathname));
        setLoading(false);
      } catch (err) {
        setError('Failed to determine application type');
        setLoading(false);
      }
    };

    detectDomain();
  }, []);

  if (loading) {
    return <LoadingScreen message="Initializing application..." />;
  }

  if (error) {
    return (
      <ErrorScreen
        title="Application Error"
        message={error}
        showRetry
        onRetry={() => window.location.reload()}
      />
    );
  }

  if (!domainInfo) {
    return (
      <ErrorScreen
        title="Unknown Domain"
        message="Unable to determine the correct application for this domain."
      />
    );
  }

  // Route to appropriate application
  switch (domainInfo.type) {
    case 'dashboard':
      // Return original App for dashboard functionality
      return <App />;

    case 'gallery':
      return (
        <GalleryApp
          domain={domainInfo.customDomain}
          subdomain={domainInfo.subdomain}
          basename={domainInfo.basename}
        />
      );

    case 'legacy':
    default:
      // Fallback to original app
      return <App />;
  }
};

export default AppRouter;
